/*
 * base on clientWidth,then transform to rem,default 320px == 20rem
 */
export function setRem (doc, win) {
  const docEl = doc.documentElement
  const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  const reCaculate = function () {
    var clientWidth = docEl.clientWidth
    // console.log(clientWidth)
    if (!clientWidth) return
    docEl.style.fontSize = 75 * (clientWidth / 750) + 'px'
  }
  if (!doc.addEventListener) return
  win.addEventListener(resizeEvt, reCaculate, false)
  doc.addEventListener('DOMContentLoaded', reCaculate, false)
}
/**
 * 自适应rem。首先判断用vw，没有支持vw再用js动态改变html的font-size
 *
 * @param {*} docEl
 * @param {*} padBaseSize
 */
export const autoRem = (docEl, padBaseSize) => {
  let width
  const resize = () => {
    const widthDynamic = Math.min(docEl.getBoundingClientRect().width, docEl.clientWidth, padBaseSize)
    if (width !== widthDynamic) {
      width = widthDynamic
      docEl.style.fontSize = `${width / 10}px`
    }
  }
  const el = document.createElement('div')
  el.setAttribute('style', 'width: 1vw')
  if (!el.style.width) {
    window.addEventListener && (window.addEventListener('orientationchange' in window ? 'orientationchange' : 'resize', resize, false))
    window.addEventListener('DOMContentLoaded', resize, false)
  } else {
    docEl.style.fontSize = '10vw'
  }
}
